import Page from "@/lib/components/Page";
import {useSession} from "@/lib/auth/auth";
import {AggregateActivity, aggregateActivityKey} from "@/lib/types";
import Header from "@/lib/components/Header";
import Activity from "@/lib/components/Activity";
import {useQuery} from "@tanstack/react-query";
import {fetchBackend} from "@/lib/backend";
import ErrorPage from "@/lib/components/ErrorPage";
import SpinnerPage from "@/lib/components/SpinnerPage";

export default function Index() {

    const {session} = useSession();

    const {data, isLoading, error} = useQuery<AggregateActivity[]>({
        queryKey: ['account', 'activity', 'all', session],
        queryFn: () => fetchBackend(`/account/activity/all`, "GET", session),
        retry: true,
        enabled: !!session,
    })

    if (error) {
        return <ErrorPage error={error}/>
    } else if (isLoading || !data) {
        return <SpinnerPage/>
    }

    return (
        <Page scrollable={true}>
            {data.length === 0 && <Header title={`Ingen aktivitet registrert.`} marginTop={6}/>}
            {data.length > 0 &&
                <Header icon={"notification"} title={`Tidligere aktivitet ( ${data.length} )`} marginTop={6}/>}
            {data.map(act => (
                <Activity key={aggregateActivityKey(act)} activity={act}/>
            ))}
        </Page>
    );
}